import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class globalNavi{
    constructor(){

        /* 必要なDOM */
        this.$trigger = $("#l-header-navi-trigger");
        this.$container = $("#l-header-navi");
        this.$logo = $("#l-header-title");
        this.$list = $("#l-header-navi li");
        this.$bg = $("#l-header-navi-bg");

        this.$pager = $("#l-header-navi-list li")


        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
        }

        effect.show(this.$list,"set");
        effect.gnaviBg(this.$bg,"set");

    }
    init() {

        let _this = this;

        let _dbClick=false;

        this.$trigger.on("click",()=>{

            if(_dbClick) return;
            _dbClick = true;

            if(_this.status.now==="close"){

                _this.show()

            }else{

                _this.out()

            }


            setTimeout(()=>_dbClick = false,1e3);

        })

        this.$pager.on("click",()=>{
            if(_this.status.now==="close") return;
            if(_dbClick) return;
            _dbClick = true;
            _this.out();
            setTimeout(()=>_dbClick = false,1e3);
        });


    }

    show(){
        this.status.now = "open";
        this.$trigger.addClass("is-open");
        this.$logo.addClass("is-open");
        this.$container.addClass("is-open");
        effect.show(this.$list,"show");
        effect.gnaviBg(this.$bg,"show");
    }
    out(){
        this.status.now = "close";
        this.$trigger.removeClass("is-open");
        this.$logo.removeClass("is-open");
        this.$container.removeClass("is-open");
        effect.show(this.$list,"out");
        effect.gnaviBg(this.$bg,"out");

    }
    resize(){

    }
}